import { render, staticRenderFns } from "./clientOverview_RequestEditContactLocation.vue?vue&type=template&id=a139f854&scoped=true&"
import script from "./clientOverview_RequestEditContactLocation.vue?vue&type=script&lang=js&"
export * from "./clientOverview_RequestEditContactLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a139f854",
  null
  
)

export default component.exports